import { render, staticRenderFns } from "./ButtonBrand.vue?vue&type=template&id=ee37a832&scoped=true"
import script from "./ButtonBrand.vue?vue&type=script&lang=js"
export * from "./ButtonBrand.vue?vue&type=script&lang=js"
import style0 from "./ButtonBrand.vue?vue&type=style&index=0&id=ee37a832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee37a832",
  null
  
)

export default component.exports